import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useServiceChargePeriods } from '@/hooks/serviceCharge';
import { ServiceChargePeriodCard } from './ServiceChargePeriodCard';
import { ServiceChargePeriodDialog } from './ServiceChargePeriodDialog';
import { Skeleton } from '@/components/ui/skeleton';

export const ServiceChargeManager = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedPeriodId, setSelectedPeriodId] = useState<string | null>(null);
  
  const { data: periods, isLoading } = useServiceChargePeriods();

  const handleEdit = (periodId: string) => {
    setSelectedPeriodId(periodId);
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    setSelectedPeriodId(null);
  };

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold">Service Charge Distribution</h2>
          <p className="text-muted-foreground mt-1">
            Configure monthly service charge pools and employee weight assignments
          </p>
        </div>
        <Button onClick={() => setIsDialogOpen(true)}>
          <Plus className="h-4 w-4 mr-2" />
          Create Period
        </Button>
      </div>

      {periods && periods.length > 0 ? (
        <div className="grid gap-4">
          {periods.map((period) => (
            <ServiceChargePeriodCard
              key={period.id}
              period={period}
              onEdit={handleEdit}
              allPeriods={periods}
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-12 border-2 border-dashed rounded-lg">
          <p className="text-muted-foreground mb-4">
            No service charge periods configured yet
          </p>
          <Button onClick={() => setIsDialogOpen(true)}>
            <Plus className="h-4 w-4 mr-2" />
            Create First Period
          </Button>
        </div>
      )}

      <ServiceChargePeriodDialog
        open={isDialogOpen}
        onOpenChange={handleDialogClose}
        periodId={selectedPeriodId}
      />
    </div>
  );
};
